
import { defineComponent, ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { Form, defineRule } from 'vee-validate';
import ValidationService from '@/services/ValidationService';
import AppButton from '@/components/UI/AppButton.vue';
import AppInput from '@/components/UI/AppInput.vue';
import { REGISTRATION_GROUP } from '@/types/enums';
import { IGroupEmit } from '@/types/interfaces';

defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');

export default defineComponent({
  name: 'GroupsAddName',
  emits: ['setGroupData'],
  components: {
    Form,
    AppInput,
    AppButton,
  },
  setup(props, context) {
    const inputData:Ref<string> = ref('');
    const router = useRouter();
    const schema = {
      groupName: 'required',
    };

    function nextStep() {
      context.emit('setGroupData', { value: inputData.value, type: REGISTRATION_GROUP.ADD_NAME } as IGroupEmit);
      router.push('add-info');
    }

    return {
      schema,
      nextStep,
      inputData,
    };
  },
});
